import React from 'react';
import './ThankYouSectionInspector.css';

function ThankYouSectionInspector({ 
  func, 
  index, 
  onUpdate,
  isPhotoPickerOpen,
  setIsPhotoPickerOpen,
  photoPickerPosition,
  setPhotoPickerPosition,
  setActivePhotoPreview,
  bringToFront
}) {
  const handleImageChange = (value) => {
    onUpdate(index, {
      ...func.props,
      image: value
    });
  };

  const handleTextChange = (textIndex, value) => {
    const newTexts = [...(func.props.thankYouText || [])];
    newTexts[textIndex] = value;
    onUpdate(index, {
      ...func.props,
      thankYouText: newTexts
    });
  };

  const addText = () => {
    const newTexts = [...(func.props.thankYouText || []), ''];
    onUpdate(index, {
      ...func.props,
      thankYouText: newTexts
    });
  };

  const removeText = (textIndex) => {
    const newTexts = func.props.thankYouText.filter((_, idx) => idx !== textIndex);
    onUpdate(index, {
      ...func.props,
      thankYouText: newTexts
    });
  };

  return (
    <div className="thank-you-inspector">
      <div className="image-section">
        <div className="input-group">
          <label>Image URL</label>
          <div 
            className="image-preview"
            onClick={(e) => {
              console.log('Image preview clicked');
                              // Only store the index - no handler function
                setActivePhotoPreview({ index });
                setIsPhotoPickerOpen(true);
                bringToFront('photoPicker');
                e.stopPropagation();
            }}
            title="Click to change photo"
          >
            {func.props.image ? (
              <img 
                src={func.props.image} 
                alt="Preview"
                onError={(e) => e.target.style.display = 'none'}
                onLoad={(e) => e.target.style.display = 'block'}
              />
            ) : (
              <div className="empty-preview">
                Click to select image
              </div>
            )}
          </div>
          <input
            type="text"
            value={func.props.image || ''}
            onChange={(e) => handleImageChange(e.target.value)}
            placeholder="Enter image URL"
            className="full-width-input"
          />
        </div>
      </div>

      <div className="texts-section">
        <h4>Thank You Messages</h4>
        {(func.props.thankYouText || []).map((text, idx) => (
          <div key={idx} className="text-item">
            <input
              type="text"
              value={text}
              onChange={(e) => handleTextChange(idx, e.target.value)}
              placeholder="Enter thank you message"
              className="full-width-input"
            />
            <button 
              onClick={() => removeText(idx)}
              className="remove-button"
              title="Remove text"
            >
              ×
            </button>
          </div>
        ))}
        <button 
          onClick={addText}
          className="add-button"
        >
          + Add Message
        </button>
      </div>
    </div>
  );
}

export default ThankYouSectionInspector; 